import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, } from 'react-router-dom';
import { Badge, Card, DropdownToggle, Spinner, UncontrolledDropdown } from 'reactstrap';
import { Icon, UserAvatar } from '../../../../components/Component';
import Content from '../../../../layout/content/Content';
import { getSingleUser } from '../../../../redux/admin/user/action';
import { findUpper } from '../../../../utils/Utils';
import BankDetails from './BankDetails';
import PersonalDetails from './PersonalDetails';
import ToastExample from "../../../../helpers/toast";
import { ColorRing } from 'react-loader-spinner'
import { getAllRoles } from '../../../../redux/common/actions';
import RolesPermission from './RolesPermission';
import UserOrder from './UserOrder';
import ReferAndEarn from './ReferAndEarn';
import Wallet from './Wallet';
import DeliverGuy from './DeliveryGuy';
function EditUser() {

    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({

        user: state.users.single_user,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });

    const { user, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [type, setType] = useState({
        personal_info: true,
        bank_details: false,
        permission: false,
        order: false,
        refer: false,
        delivery: false,
        wallet: false,
    });

    const { id } = useParams();


    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        dispatch(getAllRoles());
        dispatch(getSingleUser(id)).then((response) => {
            if (response.payload.id) {
                setLoading(false);
            }
        })

    }, [])

    // setting active tab in edit user
    const activeTab = (type) => {
        setType({ permission: false, personal_info: false, bank_details: false, order: false, refer: false, wallet: false, delivery: false });
        if (type === "PERSONAL") {
            setType({ personal_info: true, })
        } else if (type === "ROLE") {
            setType({ permission: true, })

        } else if (type === "BANK") {

            setType({ bank_details: true, })
        } else if (type === "ORDER") {

            setType({ order: true, })
        } else if (type === "REFER") {

            setType({ refer: true, })
        } else if (type === "WALLET") {

            setType({ wallet: true, })
        } else if (type === "DELIVERY") {
            setType({ delivery: true, })
        }
    }



    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) : (
                <Content>
                    <Card className="card-bordered">
                        <div className="card-aside-wrap">
                            <div
                                className={`card-aside card-aside-left user-aside  content-active}`}>
                                <div className="card-inner-group">
                                    <div className="card-inner">
                                        <div className="user-card">


                                            <div className="user-info">
                                                <span className="lead-text">{user?.name}</span>
                                                <span className="sub-text">{user?.email}</span>
                                                <Badge pill color="success">{user && user?.roles && user?.roles[0] && user?.roles[0]?.name}</Badge>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="card-inner">
                                        <div className="user-account-info py-0">
                                            <h6 className="overline-title-alt">Limtzo Wallet Amount</h6>
                                            <div className="user-balance">
                                                {user?.wallet_amount ? user?.wallet_amount : 0} <small className="currency currency-btc">INR</small>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="card-inner p-0">
                                        <ul className="link-list-menu">
                                            <li >
                                                <Link
                                                    className={
                                                        type.personal_info ? "active" : ""
                                                    }
                                                    to="#"
                                                    onClick={(e) => { activeTab('PERSONAL'); e.preventDefault() }}

                                                >
                                                    <Icon name="user-fill-c"></Icon>
                                                    <span>Personal Information</span>
                                                </Link>
                                            </li>
                                            <li >
                                                <Link
                                                    className={
                                                        type.bank_details ? "active" : ""
                                                    }
                                                    to="#"
                                                    onClick={(e) => { activeTab('BANK'); e.preventDefault() }}
                                                >
                                                    <Icon name="building-fill" />
                                                    <span>Bank Details</span>
                                                </Link>
                                            </li>
                                            <li >
                                                <Link
                                                    className={
                                                        type.permission ? "active" : ""
                                                    }
                                                    to="#"
                                                    onClick={(e) => { activeTab('ROLE'); e.preventDefault() }}
                                                >
                                                    <Icon name="shield-check-fill"></Icon>
                                                    <span>Roles</span>
                                                </Link>
                                            </li>
                                            {user?.roles && user?.roles[0] && user?.roles[0].name == "Delivery Partner" &&
                                                <li >
                                                    <Link
                                                        className={
                                                            type.delivery ? "active" : ""
                                                        }
                                                        to="#"
                                                        onClick={(e) => { activeTab('DELIVERY'); e.preventDefault() }}
                                                    >
                                                        <Icon name="account-setting-fill" />
                                                        <span>Delivery Guy</span>
                                                    </Link>
                                                </li>
                                            }
                                            <li >
                                                <Link
                                                    className={
                                                        type.order ? "active" : ""
                                                    }
                                                    to="#"
                                                    onClick={(e) => { activeTab('ORDER'); e.preventDefault() }}
                                                >
                                                    <Icon name="truck" />
                                                    <span>Orders</span>
                                                </Link>
                                            </li>
                                            {/* <li >
                                                    <Link
                                                        className={
                                                            type.refer ? "active" : ""
                                                        }
                                                        to="#"
                                                        onClick={() => activeTab('REFER')}
                                                    >
                                                        <Icon name="coin-alt-fill"></Icon>
                                                        <span>Refer & Earning</span>
                                                    </Link>
                                                </li> */}
                                            <li >
                                                <Link
                                                    className={
                                                        type.wallet ? "active" : ""
                                                    }
                                                    to="#"
                                                    onClick={(e) => { activeTab('WALLET'); e.preventDefault() }}
                                                >
                                                    <Icon name="wallet-fill" />
                                                    <span>Wallet</span>
                                                </Link>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-inner card-inner-lg">

                                {type.personal_info && !loading &&
                                    <PersonalDetails user_id={id} />
                                }
                                {type.bank_details && !loading &&
                                    <BankDetails user_id={id} />
                                }
                                {type.permission && !loading &&
                                    <RolesPermission user_id={id} />
                                }
                                {type.delivery && !loading &&
                                    <DeliverGuy user_id={id} />
                                }
                                {type.order && !loading &&
                                    <UserOrder user_id={id} />
                                }
                                {type.refer && !loading &&
                                    <ReferAndEarn user_id={id} />
                                }
                                {type.wallet && !loading &&
                                    <Wallet user_id={id} />
                                }
                            </div>
                        </div>
                    </Card>
                </Content>
            )
            }
        </React.Fragment>
    )
}

export default EditUser
